import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-[#0F392B]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="font-body text-sm">Back to Home</span>
          </Link>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white">
            Privacy Policy
          </h1>
          <p className="font-body text-white/70 mt-4">
            Last updated: December 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-[#F9F9F7]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg prose prose-lg max-w-none">
            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              1. Introduction
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              Espady Multi-Service Co. ("we," "our," or "us") respects your
              privacy and is committed to protecting your personal information.
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you use our services or visit our
              website.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              2. Information We Collect
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-4">
              We may collect the following types of information:
            </p>
            <ul className="font-body text-[#4A5568] space-y-2 mb-6 list-disc pl-6">
              <li>
                Personal identification information (name, email, phone number,
                address)
              </li>
              <li>Financial information necessary for tax preparation services</li>
              <li>Immigration documents and related personal information</li>
              <li>Business information for business services</li>
              <li>Payment information for service fees</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              3. How We Use Your Information
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="font-body text-[#4A5568] space-y-2 mb-6 list-disc pl-6">
              <li>Provide and maintain our services</li>
              <li>Process your tax returns and other financial documents</li>
              <li>Assist with immigration and notary services</li>
              <li>Communicate with you about appointments and services</li>
              <li>Improve our services and customer experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              4. Information Security
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              We implement appropriate technical and organizational security
              measures to protect your personal information against unauthorized
              access, alteration, disclosure, or destruction. However, no
              method of transmission over the Internet or electronic storage is
              100% secure.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              5. Information Sharing
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-6">
              We do not sell, trade, or rent your personal information to third
              parties. We may share your information only as necessary to
              provide our services (e.g., with the IRS for tax filing) or as
              required by law.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              6. Your Rights
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="font-body text-[#4A5568] space-y-2 mb-6 list-disc pl-6">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information (subject to legal requirements)</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-[#0F392B] mb-4">
              7. Contact Us
            </h2>
            <p className="font-body text-[#4A5568] leading-relaxed">
              If you have questions about this Privacy Policy or our practices,
              please contact us at:
            </p>
            <div className="font-body text-[#4A5568] mt-4">
              <p>Espady Multi-Service Co.</p>
              <p>1368-B S Military Trail, Suite R</p>
              <p>West Palm Beach, FL 33415</p>
              <p>Phone: 786-991-8919</p>
              <p>Email: espadywisellc@gmail.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
